import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { formatGenericDateTime } from '../../util';

import { theme } from '../../../utils/theme';

import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';

import NoTimeline from './NoTimeline';

import { Icon, IconButton, Badge, alpha } from '@mui/material';

import { useQuery } from '@tanstack/react-query';

import { getTimeline } from '../../../components/Comments/apiService';

import { ScrollableContainer } from '../../Common';


const TimelineContainer = styled.div`
  margin: 1rem 0;
`;

const TimelineTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: .8rem;
  margin: 1.5rem 0;
  font-weight: 600;
  text-transform: uppercase;
  color: ${props => props.theme.colors.mildText};
  background-color: ${props => props.theme.colors.lightBg};
  border: 1px solid ${props => props.theme.colors.border};
  padding: .5rem 1rem;
  border-radius: 5px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

const Connector = styled.div`
  margin: .5rem 0;
  border-left: 2px solid ${props => props.color || "#ccc"};
  margin-left: .4rem;
  flex-grow: 1;
`;

const TimelineDot = styled.div`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: ${props => props.color || "#ccc"};
`;

const Content = styled.div`
  /* margin: 1rem 0;
  border-left: 2px solid ${props => props.color || "#ccc"};
  padding: .5rem;
  padding-left: 2rem;
  margin-left: .5rem; */
  padding: 1.5rem 0;
  width: 100%;
`;

/* Event Styles */

const DateLine = styled.div`
  font-style: italic;
  font-size: 1.2rem;
`;

const AgentLine = styled.div`
  color: ${props => props.theme.colors.mildText};
  font-size: 1.2rem;
`;

const AgentCommentLine = styled(AgentLine)`
  font-size: 1.3rem;
  margin-top: .3rem;
`;

const ActionLine = styled.div`
  font-weight: 500;
  font-size: 1.5rem;
  margin: .6rem 0;
  /* max-width: 32rem; */
`;

const CommentLine = styled(ActionLine)`
  font-style: italic;
  background-color: ${props => props.theme.palette.grey[100]};
  border: 1px solid ${props => props.theme.palette.grey[300]};
  border-radius: 3px;
  padding: .3rem;
  letter-spacing: .1px;
`;

/* end Event Styles */

const Event = ({ event }) => {
  const { username, timestamp, data, action, comment } = event;
  return (
    <div>
      <DateLine>{formatGenericDateTime(timestamp)}</DateLine>
      {comment ? <AgentCommentLine>@{username} Commented: </AgentCommentLine> : null}
      {action ? <ActionLine>{action}</ActionLine> : null}
      {comment ? <CommentLine>"{comment}"</CommentLine> : null}
      {action ? <AgentLine>By @{username}</AgentLine> : null}
    </div>
  )
}

const TimelineBlock = ({ event, EventComponent, last, TimelineColor }) => { 
  return (
    <Container>
      <Timeline>
        <TimelineDot color={TimelineColor} />
        <Connector color={TimelineColor} />
        {last && <TimelineDot color={TimelineColor} /> }
      </Timeline>
      <Content>{EventComponent ? <EventComponent event={event} /> : <Event event={event} /> }</Content>
    </Container>
  )
}


const TimelineComponent = ({ title, events, manual = false, EventComponent, alternate = false, TimelineColor = theme.colors.primaryMid, resource = 'appointments', resource_id = '1', expand = false }) => {

  const { data } = useQuery({ 
    queryKey: ['timeline', resource, resource_id], 
    queryFn: () => getTimeline(resource, resource_id),
    enabled: !!resource && !!resource_id && !manual
  });

  let displayedEvents = manual ? events : data;

  return (
    <TimelineContainer>
      {title ? <TimelineTitle><HistoryRoundedIcon color="basic" fontSize='small' /> {title} <Badge badgeContent={data?.length} color="tertiary" sx={{marginLeft: ".8rem"}} /></TimelineTitle> : null}
      {!displayedEvents?.length ? <NoTimeline /> : null}
      <ScrollableContainer $noBorder={true} $bg="transparent" $height="20rem" $expand={expand}>
        {displayedEvents?.map((event, index) => (
          <TimelineBlock key={event?.comment_id || event?.log_id} event={event} EventComponent={EventComponent} last={index === displayedEvents?.length - 1} TimelineColor={event.comment ? theme.colors.secondaryMid : TimelineColor} />
        ))}
      </ScrollableContainer>
    </TimelineContainer>
  )
};

export default TimelineComponent;